import draftOptions from '../config/draftOptions.json'
import classNames from 'classnames';
import { findMap } from '../helpers/drafting';

export function MapSelector({ map, state, leftSide, allowEmpty, iconMode, onChange, maps }) {
    let selectedMap = {}
    if(map) {
        selectedMap = findMap(map, {withFallback: true})
    }

    function handleChange(el) {
        if (onChange)
            onChange(el.target.value);
    }

    const randomMap = '/maps/megarandom.png';

    return (
        <div className={classNames('flex', !!leftSide ? 'flex-row' : 'flex-row-reverse')}>
            {iconMode === 'small' && <img className='w-8 h-8' src={selectedMap?.iconUrl || randomMap} />}
            <select value={selectedMap.label} className={classNames('border-solid  border-[0.5px] h-8 w-32',state == "ban" && "bg-red-200", state == "pick" && "bg-green-200")} onChange={handleChange}>
                {allowEmpty && <option>(unknown)</option>}
                {maps?.sort((a, b) => a.label.localeCompare(b.label)).map(mapOption => <option value={mapOption.label}>{mapOption.label}</option>)}
            </select>
            {state && <select value={state} className='border-solid border-zinc-600 border-[0.5px] h-8 w-16'>{draftOptions.map(option => <option value={option}>{option}</option>)}</select>}
            {iconMode === 'below' && <img className='mx-auto w-20 h-20' src={selectedMap?.iconUrl || randomMap} />}
        </div>
    );
}